import script from "./CourseTextColl.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTextColl.vue?vue&type=script&setup=true&lang=js"

import "./CourseTextColl.vue?vue&type=style&index=0&id=5783a118&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5783a118"]])

export default __exports__